import { defineComponent as _defineComponent } from 'vue'
import { watch } from "vue";
  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveDocumentModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }
  function confirm() {
    emits("confirm");
  }

const __returned__ = { emits, props, close, confirm, watch, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})